import * as React from 'react';
import { FunctionComponent, PropsWithChildren } from 'react';

import BaseAutocomplete from '../../../../../../shared/components/base-autocomplete/base-autocomplete';
import BaseRenderInput from '../../../../../../shared/components/base-autocomplete/components/base-render-input/base-render-input';
import { ActiveInactiveStatusEnum } from '../../../../../../shared/enums/active-inactive-status.enum';
import { convertToSentenceCase } from '../../../../../../shared/utils/convert-to-sentence-case/convert-to-sentence-case.util';
import { mapActiveInactiveStatusEnumToItemLabelModel } from '../../../../../../shared/utils/mapping/mapping.util';
import FormControl from '../../../../../shared/components/ui/FormControl';
import { optionEquality } from '../../../../../shared/utils/option-equality/option-equality.util';
import { BasicInfoComponentProps } from '../../types/basic-info-component.props';

export const CampaignStatusSelect: FunctionComponent<
  BasicInfoComponentProps
> = (props: PropsWithChildren<BasicInfoComponentProps>) => {
  const { values, setFieldValue, handleBlur } = props;

  const optionsStatus = [
    ActiveInactiveStatusEnum.ACTIVE,
    ActiveInactiveStatusEnum.INACTIVE,
  ];

  return (
    <FormControl data-testid="campaign-status-select-form-control">
      <BaseAutocomplete
        multiple={false}
        disableClearable={false}
        freeSolo={false}
        id="status"
        value={values.status ?? null}
        onChange={(event, value) => setFieldValue('status', value)}
        onBlur={handleBlur}
        options={optionsStatus.map(mapActiveInactiveStatusEnumToItemLabelModel)}
        getOptionLabel={option => convertToSentenceCase(option.label)}
        isOptionEqualToValue={optionEquality}
        renderInput={params => (
          <BaseRenderInput
            {...params}
            errors={props.errors}
            id="status"
            label="Status"
            name="status"
            touched={props.touched}
            required
          />
        )}
      />
    </FormControl>
  );
};
